"use client";

import { useEffect } from "react";
import { CircleAlert, RefreshCw } from "lucide-react"; // Assuming Lucide icons are used in the project
import { useRouter } from "@/i18n/routing";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const Error = ({ error, reset }: ErrorProps) => {
  const router = useRouter();

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  const handleRefresh = () => {
    reset(); // This uses Next.js's built-in reset functionality
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      handleRefresh();
    }
  };

  return (
    <div className="inter flex min-h-[50vh] flex-col items-center justify-center px-4 py-16 text-center">
      <div className="mb-6 rounded-full bg-red-100 p-4">
        <CircleAlert className="h-10 w-10 text-red-500" />
      </div>

      <h1 className="urbanist mb-3 text-3xl font-bold text-gray-900">Something went wrong</h1>

      <p className="mb-8 max-w-md text-gray-600">
        We encountered an error while loading this vehicle. Please try refreshing the page.
      </p>

      <button
        onClick={handleRefresh}
        onKeyDown={handleKeyDown}
        className="inter flex items-center gap-2 rounded-md bg-primary px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:cursor-pointer hover:bg-primary-dark"
        aria-label="Refresh page"
        tabIndex={0}
      >
        <RefreshCw className="h-4 w-4" />
        <span>Refresh Page</span>
      </button>
    </div>
  );
};

export default Error;
